#import "./TeamFields.graphql"

mutation CreateTeam($name: String!) {
  createTeam(input: { name: $name }) {
    team {
      ...TeamFields
    }
  }
}
